import { ApolloProvider } from '@apollo/client';
import { Theme, ThemeProvider } from '@prenuvo/shared-library';
import MetaTags from 'react-meta-tags';
import { BrowserRouter } from 'react-router-dom';

import appInfo from '../package.json';
import {
  AuthProvider,
  FilterProvider,
  SelectedStudyProvider,
  StudiesProvider,
  UIProvider,
} from '../src/contexts';
import { client } from './client';
import AppRoutes from './routes';

const App = () => {
  return (
    <BrowserRouter>
      <ThemeProvider themeName={Theme.theme1}>
        <MetaTags>
          <meta property="version" content={appInfo.version} />
        </MetaTags>

        <ApolloProvider client={client}>
          <UIProvider>
            <AuthProvider>
              <FilterProvider>
                <StudiesProvider>
                  <SelectedStudyProvider>
                    <AppRoutes />
                  </SelectedStudyProvider>
                </StudiesProvider>
              </FilterProvider>
            </AuthProvider>
          </UIProvider>
        </ApolloProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
